import { IndustryGroupType } from '@trnsact/trnsact-shared-types';

const TRUCKING_INDUSTRY_GROUP_TYPES: string[] = [IndustryGroupType.Trucking, 'trucking_2'];

export const getDefaultAttachmentType = (industryGroupType?: string | null) =>
  industryGroupType && TRUCKING_INDUSTRY_GROUP_TYPES.includes(industryGroupType) ? 'Body' : 'Attachment';
